<div class="planning-generale">
  @for (curEvenement of evenements; track curEvenement) {
    <ng-template #ibEve>
      @if (curEvenement.type === PlanJourEveType.EVENEMENT) {
        <div class="fs-10px">
          {{ translate.instant("APPPLANSTOURNEE.PLANSJOURAGENT.CLIENT") }} {{
          curEvenement.evenement.SERVICE.CLIENT.NUCHEP }} - {{ curEvenement.evenement.SERVICE.CLIENT.NOM }}<br />
          {{ curEvenement.evenement.SERVICE.TYPESERVICE.SERVICE }}
          @if (curEvenement.hasExtraInfos === true) {
            <br />{{ translate.instant("APPPLANSTOURNEE.PLANSJOURAGENT.PROTOCOLE") }} : {{
            curEvenement.protocole != null ? curEvenement.protocole : traductionCore.getTrad("NONRENSEIGNE") }}
            <br />{{ translate.instant("APPPLANSTOURNEE.PLANSJOURAGENT.FREQUENCE") }} : {{
            curEvenement.frequence != null ? curEvenement.frequence : traductionCore.getTrad("NONRENSEIGNE") }}
            <br />{{ translate.instant("APPPLANSTOURNEE.PLANSJOURAGENT.ECARTMOY") }} : {{
            curEvenement.ecartMoy != null ? curEvenement.ecartMoy : traductionCore.getTrad("NONRENSEIGNE") }}
          }
          @if (curEvenement.dateEvtRealise != null) {
            <br />{{ translate.instant("APPPLANSTOURNEE.PLANSJOURAGENT.DATEREA") }} : {{
            curEvenement.dateEvtRealise }}
          }
        </div>
      }
      @if (curEvenement.type === PlanJourEveType.CONGES) {
        <div class="fs-10px">
          {{ translate.instant("APPPLANSTOURNEE.PLANSJOURAGENT.CONGESDU") }} {{ curEvenement.dateDebut |
          dateFormat }}
          {{ translate.instant("APPPLANSTOURNEE.PLANSJOURAGENT.CONGESAU") }} {{ curEvenement.dateFin |
          dateFormat }}
        </div>
      }
    </ng-template>
    <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
    <div [class]="curEvenement.cssClasse" [style]="curEvenement.getCssStyleSanitized(sanitizer)"
      [dirGalaTooltip]="ibEve">
    </div>
  }
</div>